import { clearAuthCookies, makeRequest, stopMasquerading } from "../util";
import { signOut } from "@/auth/firebase";

export function signout() {
  stopMasquerading();
  makeRequest("invalidate_token")
    .then(() => {
      void signOut();
      clearAuthCookies();
    })
    .catch((_error) => {
      void signOut();
      clearAuthCookies();
    });
}
